import { useNavigate, Link } from "react-router-dom"; // Add Link import
import "../CSS/style.css";
// import { useState } from 'react';

function Footer() {
  const navigate = useNavigate(); // Fixed: lowercase
  // ... your existing state & functions

  // Simplified navigation helper
  const goToPage = (path) => {
    navigate(path);
  };

  return (
    <div className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 footer-links">
              <h4>About Us</h4>
              <ul>
                <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/" onClick={() => goToPage("/")}>
                    Home
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/about" onClick={() => goToPage("/about")}>
                    About
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/services" onClick={() => goToPage("/services")}>
                    Services
                  </Link>
                </li>
                  <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/portfolio" onClick={() => goToPage("/portfolio")}>
                    Portfolio
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/career" onClick={() => goToPage("/career")}>
                    Career
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />
                  <Link to="/contact" onClick={() => goToPage("/contact")}>
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className="ion-ios-arrow-forward" />{" "}
                  <Link to="/jobs" onClick={() => goToPage("/jobs")}>
                    Internships
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />{" "}
                  <Link to="/training" onClick={() => goToPage("/training")}>
                    Courses
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />{" "}
                  <Link to="/terms" onClick={() => goToPage("/terms")}>
                    Terms &amp; condition
                  </Link>
                </li>
                <li>
                  <i className="ion-ios-arrow-forward" />{" "}
                  <Link to="/privacy" onClick={() => goToPage("/privacy")}>
                    Privacy policy
                  </Link>
                </li>
                {/* <li><i className="ion-ios-arrow-forward" /> FAQ</li>  */}
              </ul>
            </div>

            {/* Contact section unchanged - external social links stay <a> */}
            <div
              className="col-lg-3 col-md-6 footer-contact"
              style={{ fontSize: "1.5rem" }}
            >
              <h4>Contact Us</h4>
              <p>
                1st Floor G.T. Mansion
                <br />
                Patnipura Main Road,
                <br />
                Above Relaxo Footwear
                <br />
                Indore, Madhya Pradesh
                <br />
                <strong>Phone:</strong> +91-7999632018
                <br />
                <strong>Email:</strong> info@genkaix.com
                <br />
              </p>
              <div className="social-links d-flex align-items-center flex-row flex-nowrap gap-2">
                <a
                  href="https://www.linkedin.com/in/genkaix"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-linkedin" />
                </a>
                <a
                  href="https://www.linkedin.com/in/genkaix"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-facebook" />
                </a>
                <a
                  href="https://www.instagram.com/tech.genkaix/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-instagram" />
                </a>
                <a
                  href="https://www.linkedin.com/in/genkaix"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-twitter" />
                </a>
                <a
                  href="https://www.linkedin.com/in/genkaix"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-dark text-decoration-none"
                >
                  <i className="bi bi-youtube" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container">
        <div className="row align-items-center">
          <div
            className="col-md-6 copyright"
            style={{ color: "#fff", fontSize: "1.3rem" }}
          >
            Copyright © 2025 GenkaiX. All Rights Reserved.
          </div>
        </div>
      </div> */}

      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            Copyright © 2025 GenkaiX. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
